<!-- Content
  ============================================= -->
<div id="content" role="main">

    <!-- Intro
    ============================================= -->
    <section id="home">
        <div class="hero-wrap">
            <div class="hero-mask opacity-8 bg-dark"></div>
            <div class="hero-bg parallax" style="background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%);"></div>
            <div class="hero-content section d-flex fullscreen">
                <div class="container my-auto">
                    <div class="row">
                        <div class="col-12 text-center">
                            <div class="typed-strings">
                                <p>Hi, I'm Abdul Rahman</p>
                                <p>Software Engineer</p>
                                <p>MSc Cyber Security Student</p>
                                <p>Full Stack Developer</p>
                            </div>
                            <p class="text-7 fw-500 text-white mb-2 mb-md-3">Welcome</p>
                            <h2 class="text-16 fw-600 text-white mb-2 mb-md-3"><span class="typed"></span></h2>
                            <p class="text-5 text-light mb-4">based in Dublin, Ireland</p>
                            <a href="javascript:void(0)"
                                class="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2 me-2"
                                onclick="window.location.href = 'mailto:abdulrahman.haroonr@gmail.com';">Hire Me</a>
                            <a href="assets/data/AbdulRahmanHaroon.pdf" target="_blank"
                                class="btn btn-primary rounded-pill shadow-none mt-2">Download CV <i
                                    class="fas fa-download ms-1"></i></a>
                        </div>
                    </div>
                </div>
                <a href="#about" class="scroll-down-arrow text-white smooth-scroll"><span class="animated"><i
                            class="fa fa-chevron-down"></i></span></a>
            </div>
        </div>
    </section>
    <!-- Intro end -->

    <!-- About
    ============================================= -->
    <section id="about" class="section">
        <div class="container">
            <!-- Heading -->
            <div class="position-relative d-flex text-center mb-4">
                <h2 class="text-24 text-light opacity-4 text-uppercase fw-600 w-100 mb-0">About Me</h2>
                <p class="text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0">Know Me
                    More<span
                        class="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"></span>
                </p>
            </div>
            <!-- Heading end-->

            <div class="row gy-3">
                <div class="col-lg-7 col-xl-8 text-center text-lg-start">
                    <h2 class="text-7 fw-600 mb-3">I'm <span class="text-primary">Abdul Rahman Haroon,</span> a
                        Software
                        Engineer &amp; MSc Cyber Security Student
                    </h2>
                    <p>
                        BSc Gold Medalist and Software Engineer with <strong>4+ years</strong> of experience building
                        scalable web and mobile
                        applications. Contributed to the development of <strong>Umraat.com</strong>, helping generate
                        <strong>$1.1M in revenue</strong> within 5 months. Skilled in <strong>.NET Core, C#,
                            Azure</strong>,
                        and <strong>microservices architecture</strong>.
                    </p>
                    <p>
                        Currently pursuing an <strong>MSc in Cyber Security</strong> at the National College of Ireland,
                        strengthening expertise in secure software development and modern application security practices.
                    </p>
                    <p>
                        I have built and deployed high-impact platforms across the <strong>travel, real estate,
                            SD-WAN, UConnect, Partner Portal</strong>,
                        and <strong>ERP</strong> domains. My work includes integrating GPT for AI Agents, secure payment
                        gateways
                        (<strong>PayFort, Sadad, Stripe</strong>), and national authentication systems
                        (<strong>Nafath</strong>).
                    </p>
                </div>
                <div class="col-lg-5 col-xl-4">
                    <div class="ps-lg-4">
                        <ul class="list-style-2">
                            <li class=""><span class="fw-600 me-2">Name:</span>Abdul Rahman Haroon</li>
                            <li class=""><span class="fw-600 me-2">Email:</span><a
                                    href="mailto:abdulrahman.haroonr@gmail.com">abdulrahman.haroonr&#64;gmail.com</a>
                            </li>
                            <li class=""><span class="fw-600 me-2">Phone:</span>+353 087 004 2832</li>
                            <li class=""><span class="fw-600 me-2">Location:</span>Dublin, Co Dublin, Ireland</li>
                            <li class="border-0"><span class="fw-600 me-2">LinkedIn:</span><a
                                    href="https://linkedin.com/in/abdul-rahman-haroon"
                                    target="_blank">abdul-rahman-haroon</a></li>
                        </ul>
                        <a href="assets/data/AbdulRahmanHaroon.pdf" target="_blank"
                            class="btn btn-primary rounded-pill">Download
                            CV</a>
                    </div>
                </div>
            </div>

            <!-- Stats Counter -->
            <div class="brands-grid separator-border mt-3">
                <div class="row">
                    <div class="col-6 col-md-3">
                        <div class="featured-box text-center">
                            <h4 class="text-12 text-muted mb-0"><span class="counter" data-from="0"
                                    data-to="4">4</span>+</h4>
                            <p class="mb-0">Years Experience</p>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div class="featured-box text-center">
                            <h4 class="text-12 text-muted mb-0"><span class="counter" data-from="0"
                                    data-to="10">10</span>+</h4>
                            <p class="mb-0">Projects Delivered</p>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div class="featured-box text-center">
                            <h4 class="text-12 text-muted mb-0"><span class="counter" data-from="0"
                                    data-to="5">5</span>+</h4>
                            <p class="mb-0">Companies Worked With</p>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <div class="featured-box text-center">
                            <h4 class="text-12 text-muted mb-0"><span class="counter" data-from="0"
                                    data-to="15">15</span>+</h4>
                            <p class="mb-0">Technologies Used</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- About end -->

    <!-- Skills
    ============================================= -->
    <section id="skills" class="section bg-light">
        <div class="container">
            <!-- Heading -->
            <div class="position-relative d-flex text-center mb-4">
                <h2 class="text-24 text-light opacity-4 text-uppercase fw-600 w-100 mb-0">Skills</h2>
                <p class="text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0">Technology
                    Stack<span
                        class="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"></span>
                </p>
            </div>
            <!-- Heading end-->

            <div class="row gx-5">
                <div class="col-md-6">
                    <p class="text-dark fw-500 text-start mb-2">C# / .NET Core <span class="float-end">90%</span></p>
                    <div class="progress progress-sm mb-4">
                        <div class="progress-bar" role="progressbar" style="width: 90%" aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <p class="text-dark fw-500 text-start mb-2">Angular / TypeScript <span
                            class="float-end">75%</span></p>
                    <div class="progress progress-sm mb-4">
                        <div class="progress-bar" role="progressbar" style="width: 75%" aria-valuenow="75"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <p class="text-dark fw-500 text-start mb-2">JavaScript / jQuery <span
                            class="float-end">85%</span></p>
                    <div class="progress progress-sm mb-4">
                        <div class="progress-bar" role="progressbar" style="width: 85%" aria-valuenow="85"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <p class="text-dark fw-500 text-start mb-2">Flutter / Dart <span class="float-end">65%</span></p>
                    <div class="progress progress-sm mb-4">
                        <div class="progress-bar" role="progressbar" style="width: 65%" aria-valuenow="65"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
                <div class="col-md-6">
                    <p class="text-dark fw-500 text-start mb-2">MSSQL / Oracle DB / MongoDB <span
                            class="float-end">90%</span></p>
                    <div class="progress progress-sm mb-4">
                        <div class="progress-bar" role="progressbar" style="width: 90%" aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <p class="text-dark fw-500 text-start mb-2">Azure / AWS / CI-CD <span
                            class="float-end">80%</span></p>
                    <div class="progress progress-sm mb-4">
                        <div class="progress-bar" role="progressbar" style="width: 80%" aria-valuenow="80"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <p class="text-dark fw-500 text-start mb-2">Microservices / REST APIs <span
                            class="float-end">90%</span></p>
                    <div class="progress progress-sm mb-4">
                        <div class="progress-bar" role="progressbar" style="width: 90%" aria-valuenow="90"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <p class="text-dark fw-500 text-start mb-2">Cyber Security / Pen Testing <span
                            class="float-end">60%</span></p>
                    <div class="progress progress-sm mb-4">
                        <div class="progress-bar" role="progressbar" style="width: 60%" aria-valuenow="60"
                            aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>

            <!-- Tech Tags -->
            <div class="text-center mt-4">
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">C#</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">.NET Core</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Angular</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">TypeScript</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">JavaScript</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">jQuery</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Flutter</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Razor</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Git</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">TFS</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">MSSQL</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Oracle DB</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">MongoDB</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">GraphQL</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Azure</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">AWS</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">CI/CD</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Microservices</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Stripe</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">PayFort</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Dynatrace</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">Kibana</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">CyberArk</span>
                <span class="badge bg-secondary text-white px-3 py-2 me-2 mb-2">LaunchDarkly</span>
            </div>
        </div>
    </section>
    <!-- Skills end -->

    <!-- Resume
    ============================================= -->
    <section id="resume" class="section">
        <div class="container">
            <!-- Heading -->
            <div class="position-relative d-flex text-center mb-4">
                <h2 class="text-24 text-light opacity-4 text-uppercase fw-600 w-100 mb-0">Summary</h2>
                <p class="text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0">Resume<span
                        class="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"></span>
                </p>
            </div>
            <!-- Heading end-->

            <div class="row gx-5">
                <!-- My Experience -->
                <div class="col-md-12">
                    <h2 class="text-6 fw-600 mb-3"><i class="fas fa-briefcase text-primary me-2"></i>My Experience</h2>

                    <!-- Golden Times -->
                    <div class="bg-white border rounded p-3 mb-3 resume-card">
                        <p class="badge bg-primary text-2 fw-400">May 2022 - Feb 2026</p>
                        <h3 class="text-5">Application Programmer <span class="text-muted fw-400">- On-Site</span></h3>
                        <p class="text-danger">Golden Time Travel &amp; Tourism Co - Jeddah, KSA</p>
                        <ul class="resume-list mb-0">
                            <li>Led end-to-end development and launch of <strong>umraat.com</strong>, achieving 1,000+
                                monthly active users through integration with Maqam GDS and a scalable stack including
                                AWS, .NET Core, MSSQL, and PayFort.</li>
                            <li>Developed <strong>bedbank.sa</strong>, a B2B travel platform with partner integrations
                                (lolX, Agoda, HotelBeds, OHIP), and integrated GPT for an AI Agent and WalaOne for
                                reward-based booking.</li>
                            <li>Architected <strong>alwaqtaldhahabi.com</strong>, a real estate platform serving 500+
                                active users, with REGA and Nafath integrations.</li>
                            <li>Engineered <strong>soomy.sa</strong>, a property auction system handling 50+ concurrent
                                bids, and deployed the Flutter mobile app with Clean Architecture, BLOC pattern, Nafath,
                                and SMS authentication.</li>
                            <li>Embedded secure payment gateways (PayFort, Sadad), decreasing transaction failures by
                                15%.</li>
                            <li>Formulated scalable REST APIs supporting 50,000+ daily requests.</li>
                        </ul>
                    </div>

                    <!-- Uniti Solutions -->
                    <div class="bg-white border rounded p-3 mb-3 resume-card">
                        <p class="badge bg-primary text-2 fw-400">Feb 2022 - Feb 2026</p>
                        <h3 class="text-5">Software Developer <span class="text-muted fw-400">- Remote</span></h3>
                        <p class="text-danger">Uniti Solutions - Little Rock, ARK, USA</p>
                        <ul class="resume-list mb-0">
                            <li>Engaged by Uniti Solutions, executing projects under the technical supervision of Lycore
                                and Netstratum.</li>
                            <li>Programmed and optimized portal solutions incorporating Azure, C#, .NET Core, and
                                Angular, accelerating data retrieval times by 30% using Snowflake, Druid, and GraphQL.
                            </li>
                            <li>Integrated CATO into UConnect, managing secure SASE/SSE access.</li>
                            <li>Streamlined IT Managed Services by deploying automated workflows for ticket referral
                                records, cutting manual processing time by 40%.</li>
                            <li>Constructed maintainable microservices using .NET Web APIs, producing end-to-end
                                full-stack solutions that supported a 35% increase in platform traffic.</li>
                            <li>Facilitated Agile Scrum ceremonies, completing 15+ user stories per sprint.</li>
                            <li>Maintained 99.9% system uptime using Dynatrace, Kibana, CyberArk, Pendo, Rancher,
                                Hubble, and LaunchDarkly.</li>
                        </ul>
                    </div>

                    <!-- Alpha Next -->
                    <div class="bg-white border rounded p-3 mb-3 resume-card">
                        <p class="badge bg-primary text-2 fw-400">Sep 2023 - Aug 2024</p>
                        <h3 class="text-5">Lead Developer <span class="text-muted fw-400">- Remote</span></h3>
                        <p class="text-danger">Alpha Next ITech - Jeddah, KSA</p>
                        <ul class="resume-list mb-0">
                            <li>Deployed and governed ERP systems, including Finance and HR modules, supporting 2,000+
                                active employees using .NET Core, MSSQL, and JavaScript/jQuery.</li>
                            <li>Customized ERP solutions to meet core business workflows, resolving 50+ critical bugs to
                                improve overall system performance by 20%.</li>
                        </ul>
                    </div>

                    <!-- Nayel Solutions -->
                    <div class="bg-white border rounded p-3 mb-3 resume-card">
                        <p class="badge bg-primary text-2 fw-400">Mar 2019 - Jun 2022</p>
                        <h3 class="text-5">Software Engineer <span class="text-muted fw-400">- Remote</span></h3>
                        <p class="text-danger">Nayel Solutions - Islamabad, Pakistan</p>
                        <ul class="resume-list mb-0">
                            <li>Administered the university website (UBT) serving 15,000+ students using Azure, ASP.NET
                                MVC, and Oracle DB, boosting user engagement by 25%.</li>
                            <li>Designed an integrated functional dashboard with real-time insights using Chart.js,
                                adopted by 50+ administrative staff.</li>
                            <li>Transitioned an Online Travel Agency (OTA) to a microservice-level architecture, cutting
                                system latency by 40%.</li>
                        </ul>
                    </div>

                    <!-- Lycore -->
                    <div class="bg-white border rounded p-3 mb-3 resume-card">
                        <p class="badge bg-primary text-2 fw-400">Sep 2021 - Feb 2022</p>
                        <h3 class="text-5">Software Engineer <span class="text-muted fw-400">- Remote</span></h3>
                        <p class="text-danger">Lycore - Jeddah, KSA</p>
                        <ul class="resume-list mb-0">
                            <li>Built a CMS application powered by AWS, .NET Core, MSSQL, and Amazon RDS, accelerating
                                content delivery times by 35%.</li>
                            <li>Directed the development of an Authentication and Access Rights system for 100,000+
                                unique accounts.</li>
                        </ul>
                    </div>
                </div>

                <!-- Education -->
                <div class="col-md-12">
                    <h2 class="text-6 fw-600 mb-3"><i class="fas fa-graduation-cap text-primary me-2"></i>My Education
                    </h2>
                    <div class="bg-white border rounded p-3 mb-3 resume-card">
                        <p class="badge bg-primary text-2 fw-400">2026 - 2027</p>
                        <h3 class="text-5">MSc Cyber Security</h3>
                        <p class="text-danger">National College of Ireland - Dublin, Ireland</p>
                        <p class="mb-0">Modules: Security Fundamentals, Secure Programming for Web, Network Security
                            &amp; Penetration Testing,
                            Cryptography, Malware Analysis, Cloud Security, Incident Response &amp; Analytics, Forensics
                            &amp; eDiscovery</p>
                    </div>
                    <div class="bg-white border rounded p-3 mb-3 resume-card">
                        <p class="badge bg-primary text-2 fw-400">2017 - 2021</p>
                        <h3 class="text-5">BSc Major in Software Engineering</h3>
                        <p class="text-danger">Capital University of Science &amp; Technology - Pakistan</p>
                        <p class="mb-0"><strong>Gold Medalist</strong> - 3.97/4 CGPA</p>
                    </div>
                </div>

                <!-- Certifications -->
                <div class="col-md-12">
                    <h2 class="text-6 fw-600 mb-3"><i class="fas fa-certificate text-primary me-2"></i>Certifications
                    </h2>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="bg-white border rounded p-4 mb-4 resume-card text-center">
                                <i class="fab fa-microsoft text-primary text-12 mb-3"></i>
                                <h3 class="text-4">Microsoft Azure Fundamental (AZ-900)</h3>
                                <p class="badge bg-warning text-dark">In Progress</p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="bg-white border rounded p-4 mb-4 resume-card text-center">
                                <i class="fas fa-shield-alt text-primary text-12 mb-3"></i>
                                <h3 class="text-4">Hack The Box - Bruno Machine</h3>
                                <p class="badge bg-success text-white">Completed</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Resume end -->

    <!-- Achievements
    ============================================= -->
    <section id="achievements" class="section bg-light">
        <div class="container">
            <!-- Heading -->
            <div class="position-relative d-flex text-center mb-4">
                <h2 class="text-24 text-light opacity-4 text-uppercase fw-600 w-100 mb-0">Highlights</h2>
                <p class="text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0">
                    Achievements<span
                        class="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"></span>
                </p>
            </div>
            <!-- Heading end-->

            <div class="row g-4">
                <div class="col-md-6 col-lg-3">
                    <div class="bg-white rounded p-4 text-center h-100 shadow-sm achievement-card">
                        <i class="fas fa-medal text-primary text-12 mb-3 d-block"></i>
                        <h4 class="text-4 fw-600">Gold Medalist</h4>
                        <p class="text-muted mb-0">Achieved 1st position and Gold Medal Award in the 173 Software
                            Engineering batch with 3.97/4 CGPA.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="bg-white rounded p-4 text-center h-100 shadow-sm achievement-card">
                        <i class="fas fa-brain text-primary text-12 mb-3 d-block"></i>
                        <h4 class="text-4 fw-600">ML Project</h4>
                        <p class="text-muted mb-0">Developed Optimus Bug Tracker using NLP &amp; Universal Sentence
                            Encoder to minimize bug duplication by up to 98%.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="bg-white rounded p-4 text-center h-100 shadow-sm achievement-card">
                        <i class="fas fa-trophy text-primary text-12 mb-3 d-block"></i>
                        <h4 class="text-4 fw-600">IEEE Competitions</h4>
                        <p class="text-muted mb-0">2nd position IEEE Mobile App Dev Competition &amp; 1st position IEEE
                            Computer Society Programming Competition.</p>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="bg-white rounded p-4 text-center h-100 shadow-sm achievement-card">
                        <i class="fas fa-chalkboard-teacher text-primary text-12 mb-3 d-block"></i>
                        <h4 class="text-4 fw-600">Mentorship</h4>
                        <p class="text-muted mb-0">Served as Computer Lab Assistant, mentoring 40+ students in
                            Programming, OOP, Database &amp; Data Structures.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Achievements end -->

    <!-- Contact
    ============================================= -->
    <section id="contact" class="section">
        <div class="container">
            <!-- Heading -->
            <div class="position-relative d-flex text-center mb-4">
                <h2 class="text-24 text-light opacity-4 text-uppercase fw-600 w-100 mb-0">Contact</h2>
                <p class="text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0">Get in
                    Touch<span
                        class="heading-separator-line border-bottom border-3 border-primary d-block mx-auto"></span>
                </p>
            </div>
            <!-- Heading end-->

            <div class="row g-4 justify-content-center">
                <div class="col-md-6 col-lg-3">
                    <div class="bg-white border rounded p-4 text-center h-100 contact-card">
                        <i class="fas fa-envelope text-primary text-8 mb-3 d-block"></i>
                        <h4 class="text-4 fw-600 mb-2">Email</h4>
                        <a href="mailto:abdulrahman.haroonr@gmail.com"
                            class="text-muted">abdulrahman.haroonr&#64;gmail.com</a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="bg-white border rounded p-4 text-center h-100 contact-card">
                        <i class="fas fa-phone text-primary text-8 mb-3 d-block"></i>
                        <h4 class="text-4 fw-600 mb-2">Phone</h4>
                        <a href="tel:+3530870042832" class="text-muted">+353 087 004 2832</a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="bg-white border rounded p-4 text-center h-100 contact-card">
                        <i class="fab fa-linkedin text-primary text-8 mb-3 d-block"></i>
                        <h4 class="text-4 fw-600 mb-2">LinkedIn</h4>
                        <a href="https://linkedin.com/in/abdul-rahman-haroon" target="_blank" class="text-muted">Connect
                            with me</a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="bg-white border rounded p-4 text-center h-100 contact-card">
                        <i class="fas fa-map-marker-alt text-primary text-8 mb-3 d-block"></i>
                        <h4 class="text-4 fw-600 mb-2">Location</h4>
                        <p class="text-muted mb-0">Dublin, Co Dublin, Ireland</p>
                    </div>
                </div>~
            </div>
        </div>
    </section>
    <!-- Contact end -->

</div>
<!-- Content end -->
